<template>
  <div v-for="playlist in playlists" :key="playlist.id" class="list-view">
    <router-link :to="{ name: 'Playlistdetail', params: { id: playlist.id }}">
      <div class="single">
        <div class="thumbnail">
          <img :src="playlist.coverUrl" :alt="playlist.title">
        </div>
        
          <div class="info">
            <h3>{{ playlist.title }}</h3>
            <p>Created by {{ playlist.userName }}</p>
          </div>
          <div class="song-number">
            <div class="like">
              <i class="far fa-heart" @click.stop="addtoWish(playlist)" v-if="!isWish(playlist)"></i>
              <i class="fas fa-heart" @click.stop="addtoWish(playlist)" v-if="isWish(playlist)"></i>
            </div>
            <p> {{ playlist.songs.length }} songs</p>
          </div>
        
      </div>
    </router-link> 
  </div>
</template>

<script>
import { computed, ref } from 'vue'
export default {
  props: ['playlists'],
  setup(props, context) {
    const wish = ref('');
    const getWish = () => {
      wish.value = JSON.parse(localStorage.getItem('wish')) || [];
      console.log(wish.value);
    }
    const addtoWish = (like) => {
      getWish();
      console.log(wish.value);
      let index = -1;
      wish.value.forEach((item, i) => {
        if(item.id === like.id) {
          index = i;
        }
      });
      if(index === -1){
        wish.value.push(like);
      } else {
        wish.value.splice(index, 1);
        console.log(index);
      }
      localStorage.setItem('wish', JSON.stringify(wish.value));
      getWish();
    };
    const isWish = (like) => {
      const liked = wish.value.filter(item => item.id === like.id);
      if(liked.length > 0){
        return true
      } else {
        return false;
      }
    }
    return { getWish, wish, addtoWish, isWish }
  },
  created() {
    this.getWish();
  }
}
</script>

<style scoped>
  .single {
    display: flex;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    background: white;
    margin: 16px 0;
    transition: all ease 0.3s;
  }
  .single:hover {
    box-shadow: 1px 2px 3px rgba(50,50,50,0.05);
    transform: scale(1.02);
    transition: all ease 0.3s;
  }
  .detail {
    display: flex;
    align-items: center;
  }
  .thumbnail {
    max-width: 100px;
    max-height: 100px;
    overflow: hidden;
    border-radius: 10px;
  }
  img {
    max-width: 150%;
    max-height: 150%;
    display: block;
  }
  .info {
    margin: 0 30px;
  }
  .song-number {
    margin-left: auto;
    display: flex;
    align-items: center;
  }
  .song-number .like {
    margin-right: 16px;
  }
  @media only screen and (max-width: 590px) {
    .single {
      padding: 10px;
    }
    .thumbnail {
      max-width: 80px;
      max-height: 80px;
    }
    .info {
      margin: 0 15px;
    }
    .info h3 {
      font-size: 1.1rem;
    }
    .info p {
      font-size: 0.9rem;
    }
    .song-number {
      font-size: 13px;
    }
    .song-number .like {
      margin-right: 5px;
    }
  }
</style>